<ion-card class="smr-communication-card" tappable>
  <ion-card-header>
    <ion-card-title>
      <ion-toolbar>
        <ion-buttons slot="start">
          <ion-button>
            <ion-icon
              name="mail"
              color="primary"
              *ngIf="
                communication.communicationType == 'client_email' ||
                communication.communicationType == 'bulk_email'
              "
            ></ion-icon>
            <ion-icon
              name="text"
              color="primary"
              *ngIf="communication.communicationType == 'sms'"
              class="communication-item-icon"
            ></ion-icon>
          </ion-button>
        </ion-buttons>
        <ion-label color="primary">{{ title }}</ion-label>
        <ion-buttons slot="end">
          <ion-button>
            <ion-icon
              color="primary"
              name="arrow-forward"
            ></ion-icon></ion-button
        ></ion-buttons>
      </ion-toolbar>
    </ion-card-title>
  </ion-card-header>
  <ion-card-content>
    <ion-icon
      name="checkmark"
      color="primary"
      *ngIf="communication.status == 1"
      class="ion-padding-start ion-padding-end"
    ></ion-icon>
    <ion-icon
      name="close"
      color="danger"
      *ngIf="communication.status == 0"
      class="ion-padding-start ion-padding-end"
    ></ion-icon>
    <span class="communication-date">{{
      communication.datetime | salonMonsterDate : "dddd, MMMM D, Y h:mm a"
    }}</span>
    <ion-note class="ion-padding-start">
      {{ communication.getFormattedTimeElapsed() }}
    </ion-note>
  </ion-card-content>
</ion-card>
